export enum PcbRegisterEnums {
  bindingPcb = 'PcbRegister/BindingNotice', // 機台新增（預綁定）
  updatePcbName = 'PcbRegister/PcbName', // 編輯機台名稱
  updateGoods = 'PcbRegister/Goods' // 更換機台商品
}
